/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.11.4",
    versionName: "0.8.0-nightly.2026.11.4",
    versionChannel: "nightly",
    buildDate: "2026-11-04T00:12:12.287Z",
    commitHash: "633525751c385ac04f117aa069a176e652365da3",
};
